import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const hero = document.getElementById('hero-sentinel');
      const price = document.getElementById('comprar');
      const heroBottom = hero ? hero.getBoundingClientRect().bottom : 600;
      const priceTop = price ? price.getBoundingClientRect().top : Number.POSITIVE_INFINITY;
      setVisible(heroBottom < 0 && priceTop >= window.innerHeight * 0.9);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-79" data-mp="2aw37ikip0poq">{visible && <motion.a href="https://the-esl-survival-vault.impultienda.ar/checkout" initial={{
      y: '100%'
    }} animate={{
      y: 0
    }} exit={{
      y: '100%'
    }} transition={{
      duration: 0.3,
      ease: 'easeOut'
    }} className="fixed inset-x-0 bottom-0 z-40 flex h-[54px] items-center justify-center bg-vault-gold text-[15px] font-extrabold text-midnight-navy shadow-[0_-4px_18px_-4px_rgba(201,168,76,0.35)] md:hidden" data-id="element-80" data-mp="2aus1ee1rz5ug">YES, I WANT THE COMPLETE SYSTEM</motion.a>}</AnimatePresence>;
}